/**
 * Formats a YYYY-MM-DD shipment creation date as `Wednesday July 29, 2026` (en)
 * or the French-Canada equivalent.
 *
 * @param isoDate Creation date from completed-shipment confirmation
 * @param locale Active UI locale
 */
export function formatShipmentCreationDate(isoDate: string, locale: 'en' | 'fr'): string {
  const normalized = isoDate.replaceAll('-', '/');
  const [year, month, day] = normalized.split('/').map((part) => Number.parseInt(part, 10));
  if (!year || !month || !day) {
    return isoDate;
  }

  const date = new Date(Date.UTC(year, month - 1, day));
  return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-CA' : 'en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}

/**
 * Formats cancel deadline for Get Labels footer copy (date portion only).
 *
 * @param isoDateTime Local cancel deadline from completed-shipment confirmation
 * @param locale Active UI locale
 */
export function formatCancelDeadlineDate(isoDateTime: string, locale: 'en' | 'fr'): string {
  const datePart = isoDateTime.slice(0, 10);
  const normalized = datePart.replaceAll('-', '/');
  const [year, month, day] = normalized.split('/').map((part) => Number.parseInt(part, 10));
  if (!year || !month || !day) {
    return datePart;
  }

  const date = new Date(Date.UTC(year, month - 1, day));
  return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-CA' : 'en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
